import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { Header } from "../Header";

const rotasComAbas = [
  { path: "/monitoramento", label: "Visão executiva" },
  { path: "/monitoramento/carteira", label: "Carteira" },
  { path: "/monitoramento/relatorio", label: "Relatório semanal" },
];

function indiceAba(pathname: string): number | false {
  if (pathname.startsWith("/monitoramento/fornecedor")) return false;
  const i = rotasComAbas.findIndex((r) =>
    r.path === "/monitoramento"
      ? pathname === "/monitoramento"
      : pathname.startsWith(r.path)
  );
  return i >= 0 ? i : 0;
}

export const MonitoramentoLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const tabValue = indiceAba(pathname);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "grey.50" }}>
      <Header />
      <Box sx={{ maxWidth: 1280, mx: "auto", px: 2, py: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 2,
          }}
        >
          <ShowChartIcon color="primary" />
          <Typography variant="h5" component="h1" fontWeight={600}>
            Monitoramento Serasa
          </Typography>
        </Box>
        <Tabs
          value={tabValue === false ? false : tabValue}
          onChange={(_, v) => navigate(rotasComAbas[v as number].path)}
          sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
        >
          {rotasComAbas.map((r) => (
            <Tab key={r.path} label={r.label} />
          ))}
        </Tabs>
        <Outlet />
      </Box>
    </Box>
  );
};
